import { render, staticRenderFns } from "./DiscountCodesEditModal.vue?vue&type=template&id=f879aa7a&scoped=true"
import script from "./DiscountCodesEditModal.vue?vue&type=script&lang=js"
export * from "./DiscountCodesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f879aa7a",
  null
  
)

export default component.exports